<template>
  <div class="sdk">
    <sdk :nameEn="name"></sdk>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import sdk from '@/components/common/sdk.vue';
export default {
  inject: ['reload'],
  data() {
    return {
      name: '',
    };
  },
  components: {
    sdk,
  },
  methods: {
    ...mapActions(['setBg']),
  },
  watch: {
    $route: function (newVal, oldVal) {
      // 路由变化展示新文件
      console.log({ newVal, oldVal });
      if (newVal.name !== oldVal.name) {
        this.reload();
      }
    },
  },
  created() {
    this.name = this.$route.params.nameEn;
    this.setBg(this.$route.meta.showBg);
  },
};
</script>

<style lang="scss" scoped>
</style>